import React, {useRef, useState} from "react";
import cx from "clsx";
import {DesktopMenuLinkItem} from "./desktop-menu-link-item.component";
import {useIsomorphicLayoutEffect} from "react-use";
import {ILevel1MenuItem} from "@montana/models/generated/cms.interface";

export interface IDesktopMenuProps {
    selectedItemId?: string;
    onToggleDrawerMenu: () => void;
    onSetSelectedDrawerMenuItemId: (id: string) => void;
    onLeftPosChange?: (position: number) => void;
    menuItems?: ILevel1MenuItem[];
}

export const DesktopMenu: React.FC<IDesktopMenuProps> = React.memo(
    ({
        selectedItemId,
        onToggleDrawerMenu,
        onLeftPosChange,
        menuItems,
        onSetSelectedDrawerMenuItemId
    }: IDesktopMenuProps): JSX.Element | null => {
        const mainMenuRef = useRef<HTMLUListElement>(null);
        const [isHoveringOn, setIsHoveringOn] = useState<ILevel1MenuItem | undefined>(
            undefined
        );

        const onHoverMegaMenuItem = (link?: ILevel1MenuItem) => {
            setIsHoveringOn(link);
        };

        const onUnhoverMegaMenuItem = () => {
            setIsHoveringOn(undefined);
        };

        useIsomorphicLayoutEffect(() => {
            if (!onLeftPosChange || !mainMenuRef.current) return;

            const update = () => {
                if (mainMenuRef.current) {
                    onLeftPosChange(mainMenuRef.current.getBoundingClientRect().left);
                }
            };

            const observer = new ResizeObserver(update);
            observer.observe(mainMenuRef.current);

            update();

            return () => observer.disconnect();
        }, [onLeftPosChange, isHoveringOn]);

        return (
            <ul
                ref={mainMenuRef}
                className="desktop-menu">
                {menuItems?.map(
                    (menuItem: ILevel1MenuItem) =>
                        {
                            const isSelectedItemIdInSubItems = menuItem.subItems?.some(
                                (subItem) =>
                                    subItem.itemId === selectedItemId ||
                                    subItem.subItems?.some(
                                        (nestedSubItem) => nestedSubItem.itemId === selectedItemId
                                    )
                            );
                            return (menuItem.link && <li
                                key={menuItem.itemId}
                                className={cx("desktop-menu__item", {
                                    "desktop-menu__item--current": menuItem.itemId === selectedItemId || isSelectedItemIdInSubItems
                                })}
                            >
                                <DesktopMenuLinkItem
                                    isSelectedItemIdInSubItems={isSelectedItemIdInSubItems}
                                    item={menuItem}
                                    setActiveMegaMenuItem={onSetSelectedDrawerMenuItemId}
                                    onToggleDrawerMenu={onToggleDrawerMenu}
                                    onHoverItem={onHoverMegaMenuItem}
                                    onUnHoverItem={onUnhoverMegaMenuItem}
                                    isHoveringOn={isHoveringOn}
                                />
                            </li>)
                        }
                )}
            </ul>
        );
    }
);
